import Vue from 'vue'
import axios from 'axios'

export default class Request {
  constructor ({environment = null, tag = null}) {
    if (!environment) { environment = this.getEnvironment() }
    this._abortCtrl = null
    this._cancelSignal = null
    this._environment = environment
    this._tagService = tag
    this.setup()
  }

  /**
   * Actions to execute before a new request
   */
  beforeRequest () {
    // If there is a pending fetch request with associated AbortController, abort
    if (this._abortCtrl !== null) {
      console.warn('Operation canceled by the user')
      this._abortCtrl.abort('Operation canceled by the user')
    }
    // Assign a new AbortController for the latest fetch to our useRef variable
    this._abortCtrl = new AbortController()
    this._cancelSignal = this._abortCtrl.signal
  }

  /**
   * Send a delete http
   * @param url Endpoint
   * @param config Endpoint parameters
   * @param success Action to execute on success
   * @param fail Action to execute on fail
   * @returns {Promise<AxiosResponse<any>>}
   */
  delete (url, config, success, fail) {
    let serviceUrl = url
    if (this._useEndPointModel()) { serviceUrl = this._getServiceEndPoint() + url }
    if ((success != null) && (fail != null)) {
      axios.delete(serviceUrl, this._configArgs(config)).then((response) => {
        if (typeof (success) === 'function') { success(response) }
      }).catch((error) => {
        if (typeof (fail) === 'function') { fail(error) }
      })
    } else {
      return axios.delete(serviceUrl, this._configArgs(config))
    }
  }
  async get (url, config, success, fail) {
    let serviceUrl = url
    if (this._useEndPointModel()) {
      serviceUrl = this._getServiceEndPoint() + url
    }
    if ((success != null) && (fail != null)) {
      axios.get(serviceUrl, this._configArgs(config)).then((response) => {
        if (typeof (success) === 'function') { success(response) }
      }).catch((error) => {
        // console.log({message: 'Operação não concluída', status: 503, config: error.config, request: error})
        let _error = error
        if (!error.response) {
          // _error = {message: 'Serviço indisponivel.', status: 503, config: error.config, request: error.request};
        }
        if (typeof (fail) === 'function') { fail(_error) }
      })
    } else {
      return axios.get(serviceUrl, this._configArgs(config))
    }
  }
  getEnvironment () {
    switch (process.env.NODE_ENV) {
      case 'development':
        return 'dev'
      case 'homologation':
        return 'hml'
      case 'production':
        return 'prd'
    }
  }
  _getServiceEndPoint () {
    let services = Vue.prototype.$foundation.getServices()
    // for (let i = 0; i < services.length; i++) {
    //   if(services[i].tag=='das'){
    //     console.log('############## - URL DAS MODIFICADO')
    //     services[i].endpoint="[{\"url\": [\"http://35.199.120.137/prd/das\"], \"environment\": \"prd\"}, {\"url\": [\"http://35.199.120.137/hml/das\"], \"environment\": \"hml\"}, {\"url\": [\"http://35.199.120.137/dev/das\"], \"environment\": \"dev\"}, {\"url\": [\"http://localhost:5002\"], \"environment\": \"local\"}]"
    //   }
    // }

    if (!services) return
    const tagMap = {}

    for (let i = 0; services.length > i; i += 1) {
      const endPointMap = {}
      const endPoints = (typeof (services[i].endpoint) === 'string') ? JSON.parse(services[i].endpoint) : services[i].endpoint

      endPoints.forEach(function (endPoint) {
        endPointMap[endPoint.environment] = endPoint.url
      })
      tagMap[services[i].tag] = endPointMap
    }
    return tagMap[this._tagService][this._environment][0]
  }
  getServiceEndPoint ({environment = null, tagService = null}) {
    if (!environment) environment = this._environment
    if (!tagService) tagService = this._tagService
    try {
      const services = Vue.prototype.$session.get('services')

      if (!services) return
      const tagMap = {}

      for (let i = 0; services.length > i; i += 1) {
        const endPointMap = {}
        const endPoints = (typeof (services[i].endpoint) === 'string') ? JSON.parse(JSON.stringify(services[i].endpoint)) : services[i].endpoint
        endPoints.forEach(function (endPoint) {
          endPointMap[endPoint.environment] = endPoint.url
        })
        tagMap[services[i].tag] = endPointMap
      }
      return tagMap[tagService][environment][0]
    } catch (e) {
      console.log(e)
    }
  }
  _useEndPointModel () {
    return this._environment != null && this._tagService != null
  }
  _configArgs (config = {}) {
    config['signal'] = this._cancelSignal
    return config
  }
  nested (queue) {
    return axios.all(queue)
  }
  patch (url, data, config, success, fail) {
    let serviceUrl = url
    if (this._useEndPointModel()) { serviceUrl = this._getServiceEndPoint() + url }
    if ((success != null) && (fail != null)) {
      axios.patch(serviceUrl, data, this._configArgs(config)).then((response) => {
        if (typeof (success) === 'function') { success(response) }
      }).catch((error) => {
        let _error = error
        if (!error.response) {
          _error = {message: 'Operação não concluída', status: 503, config: error.config, request: error.request}
        }
        console.log(_error)
        if (typeof (fail) === 'function') { fail(_error) }
      })
    } else {
      return axios.patch(serviceUrl, data, this._configArgs(config))
    }
  }
  async post (url, data, config, success, fail) {
    let serviceUrl = url
    if (this._useEndPointModel()) { serviceUrl = this._getServiceEndPoint() + url }
    if ((success != null) && (fail != null)) {
      await axios.post(serviceUrl, data, this._configArgs(config)).then((response) => {
        if (typeof (success) === 'function') { success(response) }
      }).catch((error) => {
        let _error = error
        if (!error.response) {
          _error = {message: 'Operação não concluída', status: 503, config: error.config, request: error.request, error: error}
        }
        if (typeof (fail) === 'function') { fail(_error) }
      })
    } else {
      return axios.post(serviceUrl, data, this._configArgs(config))
    }
  }
  put (url, data, config, success, fail) {
    let serviceUrl = url
    if (this._useEndPointModel()) { serviceUrl = this._getServiceEndPoint() + url }
    if ((success != null) && (fail != null)) {
      axios.put(serviceUrl, data, this._configArgs(config)).then((response) => {
        if (typeof (success) === 'function') { success(response) }
      }).catch((error) => {
        let _error = error
        if (!error.response) {
          _error = {message: 'Operação não concluída', status: 503, config: error.config, request: error.request}
        }
        if (typeof (fail) === 'function') { fail(_error) }
      })
    } else {
      return axios.put(serviceUrl, data, this._configArgs(config))
    }
  }
  setup () {
    axios.defaults.onDownloadProgress = function (e) {
      // console.log(e);
    }
    axios.defaults.onUploadProgress = function (e) {
      // console.log(`${e.loaded} / ${e.total}`);
    }
    axios.defaults.validateStatus = function () {
      return true
    }
    if (typeof (Vue.prototype.$session) !== 'undefined') {
      let tokenSocketIo = Vue.prototype.$session.get('socket-io-id')
      let token = Vue.prototype.$session.get('token')
      axios.defaults.headers.common['Authorization'] = token
      if (tokenSocketIo !== null) axios.defaults.headers.common['TokenSocketIo'] = tokenSocketIo
      /*
      axios.interceptors.request.use((config) => {
        let tokenSocketIo = Vue.prototype.$session.get('socket-io-id')
        let token = Vue.prototype.$session.get('token')
        config.headers.Authorization = token
        if (tokenSocketIo !== null) config.headers.TokenSocketIo = tokenSocketIo
        //Vue.prototype.$bus.$emit('beginRequest')
        // to avoid overwriting if another interceptor
        // already defined the same object (meta)
        config.meta = config.meta || {}
        config.meta.requestStartedAt = new Date().getTime()
        return config
      }, function (err) {
        return Promise.reject(err)
      })
      axios.interceptors.response.use((res) => {
        //Vue.prototype.$bus.$emit('endRequest')
        console.log(`Execution time for: ${res.config.url} - ${new Date().getTime() - res.config.meta.requestStartedAt} ms`)
        return res
      }, function (error) {
        return Promise.reject(error)
      })
      */
    }
  }
}
